export const SET_STRUC_BULK_COPY_MODEL_IDS = 'SET_STRUC_BULK_COPY_MODEL_IDS';
export const STRUC_BULK_COPY_START = 'STRUC_BULK_COPY_START';
export const STRUC_BULK_COPY_SUCCESS = 'STRUC_BULK_COPY_SUCCESS';
export const STRUC_BULK_COPY_FAIL = 'STRUC_BULK_COPY_FAIL';
export const STRUC_BULK_COPY_RESET = 'STRUC_BULK_COPY_RESET';

import apiClient from 'ps-components/lib/apiClient';

export function setBulkCopyData(modelIds, gridStore) {
  return { type: SET_STRUC_BULK_COPY_MODEL_IDS, modelIds, gridStore };
}

export function resetBulkCopyReducer(resetAll) {
  return { type: STRUC_BULK_COPY_RESET, resetAll };
}

export function copyBulkModels(modelIds, joinPosition, joinText, description, publishTo, adjustment, groups) {
  return async dispatch => {
    const cleanDescription = description.replaceAll('\n', '\\n');
    let newJoinText = joinText;
    if (newJoinText === '') {
      if (joinPosition === 'after') {
        newJoinText = 'Copy';
      } else {
        newJoinText = 'Copy of';
      }
    }
    const models = modelIds.map(modelId => {
      return {
        modelId,
        joinPosition,
        joinText: newJoinText,
        description: cleanDescription,
        publishTo,
        groups: groups.map(group => (Number.isInteger(group) ? group : parseInt(group.value)))
      };
    });

    dispatch({ type: STRUC_BULK_COPY_START });
    try {
      let copyBody = {
        models
      };
      if (adjustment) copyBody.adjustment = adjustment;
      const copyResults = await apiClient.apiPost('/api/structure-modeling/copy/copyBulkData', copyBody);

      if (copyResults.status !== 200) {
        dispatch({ type: STRUC_BULK_COPY_FAIL });
      } else {
        dispatch({ type: STRUC_BULK_COPY_SUCCESS });
      }
    } catch (e) {
      dispatch({ type: STRUC_BULK_COPY_FAIL });
      throw e;
    }
  };
}
